import React from "react";
import { ShieldCheck, FileCheck2, BadgeCheck, UserCheck, ClipboardCheck, LockKeyhole } from "lucide-react";

const DEFAULT_ITEMS = [
  { icon: UserCheck, label: "Verified Owners", desc: "Shown only after the account review state is complete" },
  { icon: FileCheck2, label: "Verified Documents", desc: "Shown only after submitted documents are reviewed" },
  { icon: ClipboardCheck, label: "Office Checked", desc: "The office review decision is recorded" },
  { icon: BadgeCheck, label: "Admin Approved", desc: "The final publication decision is recorded" },
  { icon: LockKeyhole, label: "Private by Default", desc: "Public account responses omit private contact details" },
];

export default function TrustStrip({ compact = false, items = DEFAULT_ITEMS }) {
  return (
    <div
      className={`rounded-2xl border border-white/15 bg-white/10 backdrop-blur-md shadow-[0_20px_80px_rgba(0,0,0,0.22)] ${compact ? "p-3" : "p-4 sm:p-5"}`}
      data-testid="trust-strip"
    >
      <div className={`grid ${compact ? "grid-cols-2 md:grid-cols-5" : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-5"} gap-3`}>
        {items.map(({ icon: Icon, label, desc }) => (
          <div key={label} className="flex items-start gap-3 rounded-xl bg-white/10 p-3 text-left ring-1 ring-white/10">
            <div className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-full bg-emerald-400/15 text-emerald-200 ring-1 ring-emerald-300/20">
              <Icon className="h-4 w-4" />
            </div>
            <div>
              <p className="text-xs font-black uppercase tracking-[0.16em] text-white">{label}</p>
              {!compact && <p className="mt-1 text-xs leading-relaxed text-white/70">{desc}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function InlineVerificationBadges({ property = {}, className = "" }) {
  const badges = [
    { show: property.verified_owner, label: "Verified Owner", icon: UserCheck },
    { show: property.verified_documents, label: "Verified Documents", icon: FileCheck2 },
    { show: property.status === "PUBLISHED", label: "Published", icon: ShieldCheck },
  ];
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`} data-testid="verification-badges">
      {badges.filter(b => b.show).map(({ label, icon: Icon }) => (
        <span key={label} className="inline-flex items-center gap-1.5 rounded-xl bg-emerald-50/80 px-2.5 py-1 text-[10px] font-bold text-emerald-800 border border-emerald-200/50">
          <Icon className="h-3.5 w-3.5 shrink-0" /> {label}
        </span>
      ))}
      {!badges.some(b => b.show) && (
        <span className="inline-flex items-center gap-1.5 rounded-xl bg-amber-50/80 px-2.5 py-1 text-[10px] font-bold text-amber-800 border border-amber-200/50">
          <ShieldCheck className="h-3.5 w-3.5 shrink-0" /> Verification pending
        </span>
      )}
    </div>
  );
}
